__webpack_require__.p = "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets/c8ddd750d5f1c550c5e8a9158b9bc897bf97f024/_next/";